"use client";

import type { PostalCode } from "@/features/geo/shared/postal-codes";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { fieldBaseClass, labelClass } from "@/shared/ui/form/field-styles";

export function PostalStep() {
  const { next, back, canAdvance, isBusiness, postalMatch } = useWizard();
  const [{ postalCode = "" }, answer] = useStep("postal");

  return (
    <section>
      <StepHeading
        title={isBusiness ? "Hvor ligger lokalerne?" : "Hvor bor du?"}
        body={
          isBusiness
            ? "Vi bruger jeres postnummer til at finde lokale firmaer i området."
            : "Vi bruger dit postnummer til at finde lokale firmaer i dit område."
        }
      />
      <label htmlFor="wiz-postal" className={labelClass}>
        Postnummer
      </label>
      <div className="flex flex-wrap items-center gap-3">
        <input
          id="wiz-postal"
          type="text"
          inputMode="numeric"
          maxLength={4}
          placeholder="fx 2100"
          value={postalCode}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, "").slice(0, 4);
            answer({ postalCode: digits });
          }}
          className={`${fieldBaseClass} max-w-44`}
        />
        <PostalLocation match={postalMatch} code={postalCode} />
      </div>
      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}

function PostalLocation({ match, code }: { match: PostalCode | null; code: string }) {
  if (match) {
    return (
      <span className="inline-flex items-center gap-2 rounded-sm border border-border bg-paper px-3 py-2 text-sm text-ink">
        <span className="font-medium">{match.city}</span>
        <span className="text-ink-muted">{match.municipality} Kommune</span>
      </span>
    );
  }
  if (code.length === 4) {
    return <span className="text-sm text-ink-muted">Ukendt postnummer</span>;
  }
  return null;
}
